import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, MessageSquarePlus, ArrowUpRight } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle, SheetDescription } from "./ui/sheet";
import { Button } from "./ui/button";

export const MENU_AWAM = [
  { label: "Utama", href: "/#utama" },
  { label: "Mohon Bantuan", href: "/bantuan", dalaman: true },
  { label: "Program", href: "/program", dalaman: true },
  { label: "Sukarelawan", href: "/sukarelawan", dalaman: true },
  { label: "Soalan Lazim", href: "/#soalan" },
];

const BrandAwam = ({ kecil = false }) => (
  <Link
    to="/"
    data-testid="awam-brand-link"
    aria-label="Khidmat Rakyat Kamil Munim, P.061 Padang Rengas"
    className="flex min-w-0 items-center rounded-[10px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00A0E9]"
  >
    <img
      src="/logo/lockup.png"
      alt="Kamil Munim"
      width={1697}
      height={402}
      className={`${kecil ? "h-6" : "h-8"} w-auto max-w-full shrink-0 object-contain`}
    />
  </Link>
);

const kelasMenu =
  "rounded-[10px] px-3 py-2 text-sm font-semibold text-[#3F4753] transition-colors hover:bg-[#F4F5F7] hover:text-[#141B24] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00A0E9]";

export const LamanAwam = ({ children }) => {
  const [buka, setBuka] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <div className="jalur-pkr fixed inset-x-0 top-0 z-50 h-[3px]" aria-hidden="true" />

      <header className="sticky top-0 z-40 border-b border-[#E6E8EC] bg-white/92 backdrop-blur">
        <div className="mx-auto flex h-[70px] max-w-6xl items-center gap-4 px-4 sm:px-6 lg:px-8">
          <BrandAwam />

          <nav className="ml-auto hidden items-center gap-1 lg:flex" aria-label="Menu utama">
            {MENU_AWAM.map((m) =>
              m.dalaman ? (
                <Link
                  key={m.href}
                  to={m.href}
                  className={kelasMenu}
                  data-testid={`awam-menu-${m.href.slice(1)}`}
                >
                  {m.label}
                </Link>
              ) : (
                <a key={m.href} href={m.href} className={kelasMenu} data-testid={`awam-menu-${m.label.split(" ")[0].toLowerCase()}`}>
                  {m.label}
                </a>
              )
            )}
            <Link to="/login" className={kelasMenu} data-testid="awam-menu-login">
              Log Masuk Petugas
            </Link>
            <Link
              to="/aduan"
              data-testid="awam-nav-aduan-button"
              className="ml-2 inline-flex h-10 items-center gap-2 rounded-[10px] bg-[color:var(--maroon)] px-4 text-sm font-semibold text-white transition-colors hover:bg-[color:var(--maroon-gelap)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00A0E9] focus-visible:ring-offset-2"
            >
              <MessageSquarePlus className="h-4 w-4" /> Hantar Aduan
            </Link>
          </nav>

          <div className="ml-auto flex items-center gap-2 lg:hidden">
            <Link
              to="/aduan"
              data-testid="awam-nav-aduan-button-mobile"
              className="inline-flex h-11 items-center gap-1.5 rounded-[10px] bg-[color:var(--maroon)] px-3.5 text-[13px] font-semibold text-white"
            >
              <MessageSquarePlus className="h-4 w-4" /> Aduan
            </Link>
            <Sheet open={buka} onOpenChange={setBuka}>
              <SheetTrigger asChild>
                <Button
                  variant="outline"
                  size="icon"
                  className="h-11 w-11 rounded-[10px] border-[#E6E8EC] bg-white"
                  data-testid="awam-menu-toggle"
                  aria-label="Buka menu"
                >
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[300px] bg-white p-0 [&>button]:hidden">
                <SheetTitle className="sr-only">Menu navigasi awam</SheetTitle>
                <SheetDescription className="sr-only">
                  Pautan halaman khidmat rakyat P.061 Padang Rengas
                </SheetDescription>
                <div className="flex items-center justify-between border-b border-[#E6E8EC] px-4 py-4">
                  <BrandAwam />
                  <button
                    type="button"
                    onClick={() => setBuka(false)}
                    data-testid="awam-menu-close"
                    aria-label="Tutup menu"
                    className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] border border-[#E6E8EC] bg-white text-[#141B24] hover:bg-[#FAFAFA] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00A0E9]"
                  >
                    <X className="h-5 w-5" />
                  </button>
                </div>
                <nav className="flex flex-col gap-1 p-3">
                  {MENU_AWAM.map((m) =>
                    m.dalaman ? (
                      <Link
                        key={m.href}
                        to={m.href}
                        onClick={() => setBuka(false)}
                        className={`${kelasMenu} flex min-h-[44px] items-center`}
                      >
                        {m.label}
                      </Link>
                    ) : (
                      <a
                        key={m.href}
                        href={m.href}
                        onClick={() => setBuka(false)}
                        className={`${kelasMenu} min-h-[44px] flex items-center`}
                      >
                        {m.label}
                      </a>
                    )
                  )}
                  <Link
                    to="/cadangan"
                    onClick={() => setBuka(false)}
                    className={`${kelasMenu} flex min-h-[44px] items-center`}
                  >
                    Kongsi Cadangan
                  </Link>
                  <Link
                    to="/semak"
                    onClick={() => setBuka(false)}
                    className={`${kelasMenu} flex min-h-[44px] items-center`}
                  >
                    Semak Status
                  </Link>
                  <Link
                    to="/login"
                    onClick={() => setBuka(false)}
                    className={`${kelasMenu} flex min-h-[44px] items-center`}
                  >
                    Log Masuk Petugas
                  </Link>
                </nav>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </header>

      <main>{children}</main>

      <footer className="mt-20 border-t border-[#E6E8EC] bg-[#FAFAFA]">
        <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
          <div className="grid gap-8 lg:grid-cols-[1.4fr_1fr_1fr]">
            <div>
              <BrandAwam />
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#6B7280]">
                Pusat Khidmat Komuniti Padang Rengas. Satu tempat untuk memohon bantuan, melaporkan
                masalah kawasan, menyemak status kes dan menyertai program komuniti P.061 Padang
                Rengas.
              </p>
            </div>
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[color:var(--maroon)]">
                Khidmat
              </p>
              <ul className="mt-3 space-y-2">
                {[
                  { label: "Saya Perlukan Bantuan", to: "/bantuan" },
                  { label: "Laporkan Masalah", to: "/aduan" },
                  { label: "Semak Status Kes", to: "/semak" },
                  { label: "Program Komuniti", to: "/program" },
                  { label: "Jadi Sukarelawan", to: "/sukarelawan" },
                  { label: "Kongsi Cadangan", to: "/cadangan" },
                  { label: "Hubungi Kami", to: "/hubungi" },
                ].map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="text-sm font-medium text-[#3F4753] underline decoration-transparent decoration-2 underline-offset-4 transition-colors hover:text-[color:var(--maroon)] hover:decoration-[color:var(--maroon)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00A0E9]"
                      data-testid={`footer-link-${l.to.slice(1)}`}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[color:var(--maroon)]">
                Maklumat
              </p>
              <ul className="mt-3 space-y-2">
                {[
                  { label: "Dasar Privasi", to: "/dasar-privasi" },
                  { label: "Terma Penggunaan", to: "/terma" },
                  { label: "Log Masuk Petugas", to: "/login" },
                ].map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="inline-flex items-center gap-1 text-sm font-medium text-[#3F4753] underline decoration-transparent decoration-2 underline-offset-4 transition-colors hover:text-[color:var(--maroon)] hover:decoration-[color:var(--maroon)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00A0E9]"
                      data-testid={`footer-link-${l.to.slice(1)}`}
                    >
                      {l.label}
                      {l.to === "/login" && <ArrowUpRight className="h-3.5 w-3.5" />}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-10 border-t border-[#E6E8EC] pt-6">
            <p className="max-w-4xl text-[11px] leading-relaxed text-[#6B7280]" data-testid="awam-penafian">
              Penafian: Platform ini ialah saluran pengurusan aduan dan khidmat komuniti. Ia bukan
              perkhidmatan kecemasan dan tidak menggantikan saluran rasmi agensi kerajaan. Maklumat
              yang dihantar akan digunakan bagi tujuan semakan, komunikasi dan tindakan susulan yang
              berkaitan.
            </p>
            <p className="font-mono-plex mt-4 text-[11px] text-[#6B7280]">2026</p>
          </div>
        </div>
      </footer>
    </div>
  );
};
